import axios from 'axios';
import {includes} from 'lodash';
import {showErrorPage} from 'ducks/errorPage';
import ReduxStore from '../ReduxStore';
import {clearLogin, updateLogin} from 'ducks/login';

const axiosErrorHandlerInitialise = () => {
  axios.interceptors.response.use(null, (error) => {
    const {request, response, config} = error;

    if (response.status === 401) {
      ReduxStore.dispatch(clearLogin());
      ReduxStore.dispatch(updateLogin({errorMessage: 'Please login again to continue your CMA'}));
    }
    if (!config._hideErrors && !includes([400, 401, 403], response.status)) {
      let details = {};
      if (['-uat.', '-dev.', '-local.', '-test.'].some(h => window.location.hostname.indexOf(h) !== -1)) {
        details = {
          url: request.responseURL,
          method: config.method,
          body: JSON.stringify(response.data),
          status: `${response.status} ${response.statusText}`,
        };
      }
      ReduxStore.dispatch(showErrorPage({status: response.status, details}));
    }
    return Promise.reject(error);
  });
};

export default axiosErrorHandlerInitialise;
